module.exports = __webpack_public_path__ + "img/cineflick-logo@2x.c5c205dc.png";